export const useSnackbar = () => ({
  setSnackbar: (options) => {
    console.log('Snackbar:', options);
  },
});